const PULL_REQUEST = 'https://github.com/brightwes/priorities-ai/pull/';

/**
 * "#1080" in a repository Markdown file becomes a link to that pull request, so
 * a page shown from the file (the roadmap) is one click from the work it cites;
 * the file keeps the plain number. Three digits or more, so a rank like "#3"
 * stays text; a number already inside a link or a code span is left alone.
 */
export function linkPullRequests(markdown: string): string {
  return markdown.replace(/(^|[\s(,;])#(\d{3,})\b/gm, (_, before: string, n: string) => `${before}[#${n}](${PULL_REQUEST}${n})`);
}
